export default __webpack_public_path__ + "static/media/zyro-imagepaino.f0128a68.png";